import request from '../request'

const addressApis = {
    getAllAddress1: (query) => request.get(`/address-level-1?${query}`),
    getAllAddress2: (query) => request.get(`/address-level-2?${query}`),
    getAllAddress3: (query) => request.get(`/address-level-3?${query}`),
    updateAddressMetaData: (payload) => request.post(`/address-meta-data/insert`,payload)
}

export default addressApis;